/**
 * Remove spaces in phone number and replace leading 0 with +61
 */
export function cleanPhoneNumber(value: string) {
  let phoneNumber = value.replace(/\s+/g, '');
  if (phoneNumber?.indexOf('0') === 0) {
    phoneNumber = '+61' + phoneNumber.substring(1);
  }

  return phoneNumber;
}

/**
 * Display form of a stored E.164 AU mobile: +61412345678 -> +61 412 345 678.
 * Any other shape is returned unchanged rather than guessed at. Display only;
 * never write the result back to a form value or the store.
 */
export function formatMobileForDisplay(phoneNumber: string): string {
  const match = /^\+61(\d{3})(\d{3})(\d{3})$/.exec(phoneNumber || '');
  return match ? `+61 ${match[1]} ${match[2]} ${match[3]}` : phoneNumber;
}
